// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @box/platform/no-enums
export enum PlanSponsorshipType {
  FamiliesForEnterprise = 0,
}
